import { TreeView } from "devextreme-react";
import SyncIcon from "@mui/icons-material/Sync";
import { IconButton } from "@mui/material";

import { TreeViewProps } from "./TreeViewTypes";
import "./TreeView.scss";


export const Tree: React.FC<TreeViewProps> = (treeProps) => {
  const selected = treeProps.selectedCounter ? treeProps.selectedCounter : false;
  const limit = treeProps.filesLimit
  
  const label =
    limit !== undefined
      ? `${selected}/${limit} selected`
      : `${selected} selected`;

  return (
    <>
      <div className="form">
        <div className="tree-header">
          <div className="tree-header-left">
            <h2 className="cell__tree--title hq-title">{treeProps.title}</h2>
            <IconButton onClick={treeProps.handleRefreshClick} disabled={treeProps.refreshing} size="small" title={treeProps.refreshLabel}>
              <SyncIcon style={{ color: treeProps.refreshing ? "#90a4ae" : "#009cde" }} />
            </IconButton>
          </div>
          <h2
            className={`cell ${selected && Number(selected) > 0 ? "cell__counter hq-title" : "cell--hide"}`}
          >{label}</h2>
        </div>
        <div className={treeProps.headerSlot ? "tree-search-wrapper" : undefined}>
          <TreeView {...treeProps} ref={treeProps.reference} />
          {treeProps.headerSlot && (
            <div className="tree-search-slot">
              {treeProps.headerSlot}
            </div>
          )}
        </div>
      </div>
    </>
  );
};